import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Row, Col } from 'react-bootstrap';
import { toast } from 'react-toastify';
import {
  updateQuestionGroup,
  getQuestionGroupById
} from 'services/questionGroups';
import PropTypes from 'prop-types';

const EditQuestionGroupModal = ({
  group_id,
  show,
  handleClose,
  refreshGroups
}) => {
  const [groupData, setGroupData] = useState({
    title: '',
    description: '',
    order_index: '',
    show_description: false,
    show_title: false
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (group_id) {
      setLoading(true);
      getQuestionGroupById(group_id)
        .then(response => {
          if (response.result && response.questionGroup) {
            console.log('response.questionGroup', response.questionGroup);
            setGroupData({
              ...response.questionGroup,
              show_description: Boolean(
                response.questionGroup.show_description
              ),
              show_title:
                response.questionGroup.show_title === null
                  ? true
                  : Boolean(response.questionGroup.show_title)
            });
          } else {
            toast.error('Error al cargar los datos del grupo.', {
              theme: 'colored'
            });
          }
        })
        .catch(error => {
          console.error('Error al cargar los datos del grupo:', error);
          toast.error('Error al cargar los datos del grupo.', {
            theme: 'colored'
          });
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [group_id]);

  const handleSubmit = e => {
    e.preventDefault();

    // Prepara los datos para enviar, convirtiendo descripción vacía a null
    const dataToSend = {
      ...groupData,
      description:
        groupData.description && groupData.description.trim()
          ? groupData.description.trim()
          : null
    };

    updateQuestionGroup(group_id, dataToSend)
      .then(response => {
        if (response.result) {
          toast.success('Grupo de preguntas actualizado exitosamente.', {
            theme: 'colored'
          });
          refreshGroups(); // Recargar los datos en la tabla
          handleClose(); // Cerrar el modal
        } else {
          toast.error('Error al actualizar el grupo de preguntas.', {
            theme: 'colored'
          });
        }
      })
      .catch(error => {
        console.error('Error al actualizar el grupo de preguntas:', error);
        toast.error('Error al actualizar el grupo de preguntas.', {
          theme: 'colored'
        });
      });
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Editar Grupo de Preguntas</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {loading ? (
          <div className="text-center py-3">Cargando datos...</div>
        ) : (
          <Form onSubmit={handleSubmit}>
            <Row className="g-2">
              <Col md={12}>
                <Form.Group>
                  <Form.Label>Título</Form.Label>
                  <Form.Control
                    type="text"
                    name="title"
                    value={groupData.title || ''}
                    onChange={e =>
                      setGroupData({ ...groupData, title: e.target.value })
                    }
                    placeholder="Título del grupo"
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={12}>
                <Form.Group>
                  <Form.Check
                    type="checkbox"
                    id="show_title_edit_group"
                    name="show_title"
                    checked={groupData.show_title || false}
                    onChange={e =>
                      setGroupData({
                        ...groupData,
                        show_title: e.target.checked
                      })
                    }
                    label="Mostrar este título en la encuesta"
                  />
                </Form.Group>
              </Col>
              <Col md={12}>
                <Form.Group>
                  <Form.Label>Descripción</Form.Label>
                  <Form.Control
                    type="text"
                    name="description"
                    value={groupData.description || ''}
                    onChange={e =>
                      setGroupData({
                        ...groupData,
                        description: e.target.value
                      })
                    }
                    placeholder="Descripción del grupo (opcional)"
                  />
                </Form.Group>
              </Col>
              <Col md={12}>
                <Form.Group>
                  <Form.Check
                    type="checkbox"
                    id="show_description_edit_group"
                    name="show_description"
                    checked={groupData.show_description || false}
                    onChange={e =>
                      setGroupData({
                        ...groupData,
                        show_description: e.target.checked
                      })
                    }
                    label="Mostrar esta descripción en la encuesta"
                  />
                </Form.Group>
              </Col>
              <Col md={12}>
                <Form.Group>
                  <Form.Label>Orden</Form.Label>
                  <Form.Control
                    type="number"
                    name="order_index"
                    value={groupData.order_index || ''}
                    onChange={e =>
                      setGroupData({
                        ...groupData,
                        order_index: e.target.value
                      })
                    }
                    placeholder="Orden"
                    required
                  />
                </Form.Group>
              </Col>
            </Row>
            <div className="d-flex justify-content-end mt-3">
              <Button variant="secondary" onClick={handleClose}>
                Cancelar
              </Button>
              <Button variant="primary" type="submit" className="ms-2">
                Guardar Cambios
              </Button>
            </div>
          </Form>
        )}
      </Modal.Body>
    </Modal>
  );
};

EditQuestionGroupModal.propTypes = {
  group_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  show: PropTypes.bool,
  handleClose: PropTypes.func,
  refreshGroups: PropTypes.func
};

export default EditQuestionGroupModal;
